class ByobQuickBuyCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.BYOB.VARIANTCHANGE,
      this.onVariantChange.bind(this),
    )
  }

  onVariantChange(variantTitle) {
    this.els.slide.elements.forEach(slide => {
      slide.setAttribute('aria-hidden', 'true')
    })

    this.els.slide.elements.forEach(slide => {
      const imageVariant = slide.getAttribute('data-image-variant')
      if (imageVariant && imageVariant === variantTitle.detail.thisVariantTitle) {
        slide.setAttribute('aria-hidden', 'false')
      }
    })

    const hasCarousel = this.carousel != null

    if (hasCarousel) {
      this.carousel.destroy()
      this.carousel = null
    }

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: `${this.els.slide.selector}:not([aria-hidden='true'])`,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 2.2,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.5,
            },
          },
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('byob-quick-buy-carousel')) {
  customElements.define('byob-quick-buy-carousel', ByobQuickBuyCarousel)
}
